'use client';

import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';

import { CustomLink } from '@/app/_components/CustomLink';
import { Image } from '@/components/client';
import { DONATION_ROUTES, WELLO_IMAGE_PREFIX_URL } from '@/constants';

import { MarketButton } from './MarketButton';

const REVIEW_IMAGES = [
  `${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market/photo-review-1.png`,
  `${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market/photo-review-2.png`,
  `${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market/photo-review-3.png`,
  `${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market/photo-review-4.png`,
  `${WELLO_IMAGE_PREFIX_URL}/static/event/home-love/market/photo-review-5.png`,
];

const INTERVAL_MS = 2000;

export const PhotoReviewSection = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % REVIEW_IMAGES.length);
    }, INTERVAL_MS);

    return () => clearInterval(timer);
  }, []);

  return (
    <section
      id="photo-review"
      className="flex w-full scroll-mt-46 flex-col items-center gap-32 overflow-hidden bg-Gray-black px-32 py-60"
    >
      <div className="flex w-full max-w-[375px] flex-col items-center gap-20">
        <div className="rounded-xxlarge bg-[#f6e0cf] px-20 py-6">
          <p className="text-center font-700 text-Gray-black typo-body1">
            Event 6
          </p>
        </div>

        <div className="flex flex-col items-center gap-8 text-center">
          <p className="font-700 text-[#f6e0cf] typo-h7">답례품 수령 후,</p>
          <h2 className="font-800 text-[#f6e0cf] typo-h4">
            포토후기 남기면
            <br />
            웰포인트 1,000원
          </h2>
        </div>
      </div>

      <div className="flex w-full max-w-[375px] flex-col items-center gap-24">
        <div className="flex w-full flex-col items-center gap-16 rounded-xxlarge bg-Gray-200 px-10 pt-28">
          <div className="relative h-253 w-160 overflow-hidden rounded-t-xlarge shadow-[0_0_8px_rgba(0,0,0,0.04),0_-8px_60px_rgba(0,0,0,0.05)]">
            {REVIEW_IMAGES.map((src, index) => (
              <motion.div
                key={src}
                initial={false}
                animate={{ opacity: index === currentIndex ? 1 : 0 }}
                transition={{ duration: 0.3 }}
                className="absolute inset-0"
              >
                <Image
                  src={src}
                  alt={`포토후기 예시 ${index + 1}`}
                  fill
                  sizes="160px"
                  className="object-cover object-top"
                  preload={index === 0}
                />
              </motion.div>
            ))}
          </div>
        </div>

        <MarketButton className="w-full" asChild dimensions="H56">
          <CustomLink href={DONATION_ROUTES.DONATION_MY_ORDERS.pathname}>
            포토후기 남기고 웰포인트 받기
          </CustomLink>
        </MarketButton>
      </div>
    </section>
  );
};
